import OnlinePaymentTransactionResourceModel from '../../generated/types/model/resource/OnlinePaymentTransactionResourceModel';

export default class OnlinePaymentTransactionResourceViewModel extends OnlinePaymentTransactionResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
